import { IEmailTypes } from 'props';
import { IEmailTemplateContactInputModel, IEmailTemplateNewPasswordInputModel } from 'inputModels';
import api from '../services/api/axios';
import { API_BASE_URL } from '../config/apiConfig';

interface ISendEmailProps {
  to: string;
  value?: string;
  type: string;
  withUrl?: boolean;
  pathResource: string;
  options?: {
    companyName?: string;
    id?: string;
  };
}
export const emailTypes: { [key: string]: IEmailTypes } = {
  activeAccount: {
    subject: 'Ativação de conta',
    description: 'Utilize o código abaixo para ativar sua conta no Legal Control Hub:',
    presentation:
      '<b>Seja bem-vindo ao LegalHub!</b>👋`<br><p style="text-indent: 20px;font-size: 16px;color: #707070; ">É um prazer ter você utilizando nosso sistema. Estamos comprometidos em proporcionar a melhor experiência para você!<br>Para te ajudar no primeiro acesso e na navegação pelo LegalHub, anexamos um tutorial em <b>PDF</b> com todas as informações necessárias. Se tiver dúvidas, estamos à disposição para ajudar.</p ><br><b style="color: #707070; ">Bom uso do LegalHub! 🚀</b>',
  },
  reactiveAccount: {
    subject: 'Reativação de Conta',
    description: 'Utilize o código abaixo para reativar sua conta no Legal Control Hub:',
  },
  resetPassword: {
    subject: 'Redefinição de senha',
    description: 'Utilize o código abaixo para redefinir sua senha:',
  },
  activeContact: {
    subject: 'Ativação de contato',
    description: 'Seu código para ativar o contato é o:',
  },
  confirmEmailColaborator: {
    subject: 'Ativação de conta de colaborador',
    description: `Utilize a senha abaixo para acessar sua conta de colaborador da empresa COMPANY_NAME no Legal Control Hub:`,
  },
  confirmNewEmail: {
    subject: 'Confirmação de e-mail',
    description: 'Utilize o código abaixo para confirmar o e-mail inserido no Legal Control Hub:',
  },
  newService: {
    subject: 'Nova solicitação ou demanda recebida',
    description: 'Você recebeu uma nova solicitação ou demanda',
  },
  newDateLimitService: {
    subject: 'Data da solicitação ou demanda alterada',
    description: 'Uma nova data foi inserida na solicitação ou demanda',
    url: `${API_BASE_URL}/approvalsolicitation`,
  },
  newContactRequestReceived: {
    subject: 'Solicitação de contato',
    description: 'Você recebeu uma nova solicitação de contato',
    url: `${API_BASE_URL}/request`,
  },
  newMessageReceived: {
    subject: 'Nova mensagem',
    description: 'Você recebeu uma nova mensagem',
    url: `${API_BASE_URL}/contacts`,
  },
  inviteFriend: {
    subject: 'Convite de amigo',
    description: 'Você foi convidado para fazer parte do Legal Control Hub',
  },
};
export const sendEmail = async ({ to, value, type, options, pathResource }: ISendEmailProps) =>
  new Promise<void>((resolve, reject) => {
    const emailType = emailTypes[type];
    api
      .post('email/send-email', {
        ...{
          ...emailType,
          description: emailType.description.replace('COMPANY_NAME', options?.companyName || ''),
        },
        to,
        value,
        pathResource
      })
      .then(() => resolve())
      .catch((error: any) => reject(error));
  });
export const sendCodeEmail = async ({ to, type,pathResource }: ISendEmailProps) =>
  new Promise<string>((resolve, reject) => {
    const emailType = emailTypes[type];
    api
      .post('email/send-code-email', {
        ...{ ...emailType },
        to,
        pathResource
      })
      .then((res) => resolve(res.data))
      .catch((error: any) => reject(error));
  });

export const sendInviteFriendEmail = async ({ to, type,pathResource }: ISendEmailProps) => {
  return new Promise<void>((resolve, reject) => {
    const emailType = emailTypes[type];
    api
      .post('email/send-invite-friend-email', {
        ...{ ...emailType },
        to,
        pathResource
      })
      .then(() => resolve())
      .catch((error: any) => reject(error));
  });
};

export const sendContactEmail = async (input: IEmailTemplateContactInputModel) =>
  new Promise<void>((resolve, reject) => {
    api
      .post('email/send-contact-email', input, { headers: { 'Content-Type': 'application/json' } })
      .then(() => resolve())
      .catch((error: any) => reject(error));
  });

export const sendNewPasswordEmail = async (input: IEmailTemplateNewPasswordInputModel) =>
  new Promise<void>((resolve, reject) => {
    api
      .post('email/send-new-password-email', input, {
        headers: { 'Content-Type': 'application/json' },
      })
      .then(() => resolve())
      .catch((error: any) => reject(error));
  });
